import { render } from "./DateInput.vue?vue&type=template&id=243c1df5&scoped=true"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"

import "./DateInput.vue?vue&type=style&index=0&id=243c1df5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243c1df5"]])

export default __exports__